import { expandEmoticons } from "@/lib/emoticons";

export const QUICK_REACTIONS = [
  "👍", "❤️", "😅", "😉", "🎉", "🥰", "😘", "😍",
  "😂", "😮", "👏", "😴", "😋", "🥳", "🤗", "🔥",
] as const;

/** Noto Emoji Animation (Google, CC BY 4.0) — public/emoji-anim/ */
const NOTO_ANIM: Record<string, string> = {
  "😂": "1f602.webp",
  "❤️": "2764.webp",
  "❤": "2764.webp",
  "♥": "2764.webp",
  "👍": "1f44d.webp",
  "😮": "1f62e.webp",
  "😢": "1f622.webp",
  "🙏": "1f64f.webp",
  "😅": "1f605.webp",
  "😉": "1f609.webp",
  "🎉": "1f389.webp",
  "🥰": "1f970.webp",
  "😘": "1f618.webp",
  "😍": "1f60d.webp",
  "👏": "1f44f.webp",
  "😴": "1f634.webp",
  "😋": "1f60b.webp",
  "🥳": "1f973.webp",
  "🤗": "1f917.webp",
  "🔥": "1f525.webp",
};

export function stripEmojiTone(emoji: string): string {
  return emoji.replace(/\uFE0F/g, "").replace(/\u200D/g, "");
}

export function notoAnimSrc(emoji: string): string | null {
  const file = NOTO_ANIM[emoji] || NOTO_ANIM[stripEmojiTone(emoji)];
  if (!file) return null;
  const base = import.meta.env.BASE_URL || "./";
  return `${base}emoji-anim/${file}`;
}

export function NotoReactionFace({
  emoji,
  className = "chat-noto-react",
}: {
  emoji: string;
  className?: string;
}) {
  const src = notoAnimSrc(emoji);
  if (!src) return <>{emoji}</>;
  return <img className={className} src={src} alt="" draggable={false} />;
}

function graphemes(text: string): string[] {
  if (typeof Intl !== "undefined" && "Segmenter" in Intl) {
    return [...new Intl.Segmenter("en", { granularity: "grapheme" }).segment(text)].map(
      (s) => s.segment
    );
  }
  return Array.from(text);
}

const PICT = /^\p{Extended_Pictographic}/u;

/** 1 à 3 emoji seuls (éventuellement séparés d’espaces), sinon null. */
export function loneMessageEmojis(raw: string): string[] | null {
  const t = expandEmoticons(raw).trim();
  if (!t) return null;
  const segs = graphemes(t).filter((s) => !/^\s+$/.test(s));
  if (segs.length < 1 || segs.length > 3) return null;
  if (!segs.every((s) => PICT.test(s) || /^(❤|♥)/.test(stripEmojiTone(s)))) return null;
  return segs;
}
